import { render } from "./DetailsGoal.vue?vue&type=template&id=44dcfd30"
import script from "./DetailsGoal.vue?vue&type=script&lang=js"
export * from "./DetailsGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__